<template>
    <div class="md:flex-row flex flex-col">
        <aside class="md:w-220px w-full">
            <h5 class="mt-0">{{ $t('globals.sections') }}</h5>
            <div class="list-group">
                <a class="list-group-item px-2 py-2" :class="{ active : (hash === 'basic-information' || hash === '') }" href="javascript:;" @click="setHash('basic-information')">
                    <span class="icon icon-building icon-lg icon-fw"></span>
                    {{ $t('organization_details.basic_information') }}
                </a>
                <a class="list-group-item px-2 py-2" :class="{ active : hash === 'organization-staff' }" href="javascript:;" @click="setHash('organization-staff')">
                    <span class="icon icon-group icon-lg icon-fw"></span>
                    {{ $t('organization_details.organization_staff') }}
                </a>
                <a class="list-group-item px-2 py-2" :class="{ active : hash === 'documents' }" href="javascript:;" @click="setHash('documents')">
                    <span class="icon icon-briefcase icon-lg icon-fw"></span>
                    {{ $t('organization_details.documents') }}
                </a>
            </div>
        </aside>
        <div class="md:pl-15px flex-1">
            <div v-if="hash === 'basic-information' || hash === ''">
                <div class="mb-4">
                    <h4 class="mt-0 mb-1">{{ $t('organization_details.basic_information') }}</h4>
                    <p class="mb-0">{{ $t('organization_details.basic_information_info') }}</p>
                </div>
                <div class="lg:w-5/6 w-full mb-3">
                    <logo-section :organization="organization"></logo-section>
                </div>
                <div class="lg:w-5/6 w-full">
                    <basic-information-form :organization="organization"></basic-information-form>
                </div>
            </div>
            <div v-else-if="hash === 'organization-staff'">
                <div class="mb-4">
                    <h4 class="mt-0 mb-1">{{ $t('organization_details.organization_staff') }}</h4>
                    <p class="mb-0">{{ $t('organization_details.organization_staff_info') }}</p>
                </div>
                <div class="lg:w-5/6 w-full">
                    <organization-staff-form :organization="organization"></organization-staff-form>
                </div>
            </div>
            <div v-else-if="hash === 'documents'">
                <div class="mb-4">
                    <h4 class="mt-0 mb-1">{{ $t('organization_details.documents') }}</h4>
                    <p class="mb-0">{{ $t('organization_details.documents_info') }}</p>
                </div>
                <div class="lg:w-5/6 w-full mb-3">
                    <public-documents-section
                        :terms-updated-at="termsUpdatedAt"
                        :privacy-updated-at="privacyUpdatedAt"
                        :suppliers-updated-at="suppliersUpdatedAt"
                    ></public-documents-section>
                </div>
                <div class="lg:w-5/6 w-full">
                    <organization-documents-section
                        :organization="organization"
                    ></organization-documents-section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LogoSection from './partials/logo-section.vue';
import BasicInformationForm from './partials/basic-information-form.vue';
import OrganizationStaffForm from './partials/organization-staff-form.vue';
import PublicDocumentsSection from './partials/public-documents-section.vue';
import OrganizationDocumentsSection from './partials/organization-documents-section.vue';

export default {
    components: {
        'logo-section': LogoSection,
        'basic-information-form': BasicInformationForm,
        'organization-staff-form': OrganizationStaffForm,
        'public-documents-section': PublicDocumentsSection,
        'organization-documents-section': OrganizationDocumentsSection,
    },

    props: {
        organization: {
            type: Object,
            required: true,
        },
        termsUpdatedAt: {
            type: String,
            required: true,
        },
        privacyUpdatedAt: {
            type: String,
            required: true,
        },
        suppliersUpdatedAt: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            hash: window.location.hash.substr(1),
        };
    },

    created() {
        window.addEventListener('popstate', () => {
            const hash = window.location.hash.substr(1);
            this.broadcastHashChange(hash);
        });
    },

    methods: {
        setHash(hash) {
            window.history.pushState(null, null, `#${hash}`);
            this.broadcastHashChange(hash);
        },

        broadcastHashChange(hash) {
            this.hash = hash;
        },
    },
};
</script>
